<template>
  <div
    class="sendMessgeBox"
    style="background: #fff"
    :style="{ minHeight: screenHeight - 151 + 'px' }"
  >
    <div v-if="!lookMessgeShow">
      <div class="titles">编辑</div>
      <div class="mb20">
        <el-input
          v-model="MessgeTitle"
          placeholder="请输入标题"
          style="width: 1200px"
        ></el-input>
      </div>
      <div class="mb20 maxHeight600">
        <UE ref="ue"></UE>
      </div>
      <div class="flex_align flex_between" style="width: 1200px">
        <div class="flex_align">
          <div class="flex_align">
            <div>类别:</div>
            <el-select
              v-model="MessgeType"
              placeholder="请选择"
              class="ml10"
              size="mini"
              style="width: 100px"
              clearable
            >
              <el-option
                v-for="item in MessgeTypeList"
                :key="item.dataValue"
                :label="item.dataName"
                :value="item.dataValue"
              ></el-option>
            </el-select>
          </div>
          <div class="ml90">
            <div class="flex_align">
              <div>
                <el-checkbox v-model="checked"></el-checkbox>
              </div>
              <div class="ml10">
                是否需要回执&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发送对象:
              </div>
              <div class="co_40" @click="receiveVisible = true">
                请选择发送对象
              </div>
            </div>
          </div>
        </div>
        <div class="flex_align">
          <el-button plain size="mini" @click="sendUecontent">发布</el-button>
          <el-button plain size="mini" @click="lookmessge">预览</el-button>
          <el-button plain size="mini" @click="messgeback">返回</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      title="发送对象"
      :visible.sync="receiveVisible"
      width="30%"
      center
    >
      <div style="max-height: 400px; overflow-y: auto">
        <el-tree
          :data="receivedata"
          show-checkbox
          node-key="id"
          ref="tree"
          highlight-current
          :props="defaultProps"
          @node-click="handleNodeClick"
        ></el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="receiveVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="choose" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <lookMessge
      ref="lookMessges"
      v-if="lookMessgeShow"
      @previewBack="previewBack"
    ></lookMessge>
  </div>
</template>

<script>
import lookMessge from "./lookMessge";
import UE from "./../../components/Ue/UE";
export default {
  name: "sendMessge",
  components: {
    UE: UE,
    lookMessge: lookMessge,
  },
  data() {
    return {
      receivedata: [],
      defaultProps: {
        children: "childUsers",
        label: "suName",
        value: "suId",
      },
      lookMessgeShow: false,
      receiveVisible: false,
      checked: false,
      MessgeType: "",
      MessgeTitle: "",
      sendMessgeShow: "send",
      screenHeight: document.documentElement.clientHeight, //屏幕高度
      MessgeTypeList: [
        {
          value: "danger",
          label: "喜讯",
        },
        {
          value: "info",
          label: "通知",
        },
        {
          value: "warning",
          label: "公告",
        },
      ],
      chooseList: [],
    };
  },
  methods: {
    previewBack(data) {
      this.lookMessgeShow = false;
      this.MessgeTitle = data.messageTitle;
      setTimeout(() => {
        this.$refs.ue.setText(data.messageContent);
      }, 400);
      // this.$refs.ue.setText(data.messageContent)
    },
    lookmessge() {
      let data = {};
      data.messageTitle = this.MessgeTitle;
      data.createBy = this.$store.getters.info.permissions;
      data.createTime = this.MGridUtil.getNowFormatDate();
      data.messageContent = this.$refs.ue.getUEContent();
      this.lookMessgeShow = true;
      this.$nextTick(function () {
        this.$refs.lookMessges.lookMessgeInfo(data);
      });
    },
    handleNodeClick(node) {
      // this.chooseList=this.$refs.tree.getCheckedNodes()
    },
    choose() {
      let list = [];
      list = this.$refs.tree.getCheckedNodes();
      if (list.length == 0) {
        this.MGridUtil.MessageShow("请选择发送对象", "warning");
        return false;
      }
      if (list[0].childUsers) {
        list = list.slice(1, list.length);
      }
      let arr = [];
      for (let i in list) {
        arr.push(list[i].suId);
      }
      this.chooseList = arr.toString();
      this.receiveVisible = false;
    },
    //返回sendMessgeBack
    messgeback() {
      this.$emit("sendMessgeBack", false);
    },
    //
    getMessgeTypeList() {
      var obj = "messageType";
      // this.request(
      //   "Post",
      //   this.adminApi.marketing.getDataByCode + obj,
      //   {},
      //   false
      // ).then(res => {
      //   this.MessgeTypeList = res.mapInfo.dmessageType;
      // });
    },
    //获取值
    sendUecontent() {
      let data = {};
      if (this.MessgeTitle == "") {
        this.MGridUtil.MessageShow("请输入标题", "warning");
        return false;
      }
      data.messageTitle = this.MessgeTitle;
      if (this.MessgeType == "") {
        this.MGridUtil.MessageShow("请选择类别", "warning");
        return false;
      }
      data.messageType = this.MessgeType;
      if (this.$refs.ue.getUEContent() == "") {
        this.MGridUtil.MessageShow("请输入消息内容", "warning");
        return false;
      }
      data.messageContent = this.$refs.ue.getUEContent();
      if (this.checked) {
        data.isFeedback = 1;
      } else {
        data.isFeedback = 2;
      }
      if (this.chooseList.length == 0) {
        this.MGridUtil.MessageShow("请选择发送对象", "warning");
        return false;
      }
      data.receiveIds = this.chooseList;
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.POST,
      //   this.adminApi.homerenovation.addErpMessageSend,
      //   data,
      //   false,
      //   true
      // ).then((res) => {
      //   if (res.status == 200) {
      //     this.messgeback();
      //     // this.$eventHub.$emit("getMessageAllList", { bool: true });
      //   } else if (res.status == 400) {
      //     this.MGridUtil.MessageShow("文本错误", "warning");
      //     return false;
      //   }
      // });
    },
    getUsersByStore() {
      let data = {};
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.POST,
      //   this.adminApi.homerenovation.getUsersByStore,
      //   data,
      //   false
      // ).then((res) => {
      //   this.receivedata = res.rows;
      //   for (let i in this.receivedata) {
      //     this.receivedata[i].suId = this.receivedata[i].id;
      //     this.receivedata[i].suName = this.receivedata[i].name;
      //   }
      // });
    },
  },
  created() {},
  mounted() {
    this.$refs.ue.style = "width:1120px";
    this.getUsersByStore();
    this.getMessgeTypeList();
  },
};
</script>

<style lang="scss" scoped>
.maxHeight600 {
  max-height: 600px;
  overflow: auto;
}
.co_40 {
  color: #409eff;
  cursor: pointer;
}
.ml90 {
  margin-left: 90px;
}
.ml10 {
  margin-left: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.sendMessgeBox {
  width: 100%;
  padding: 30px;
}
.titles {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/sendMessge.vue